// This is a simplified Tailwind CSS-based Modal component
const OtpVerifyModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null

  return (
    // Backdrop/Overlay - Changed background to bg-transparent
    <div className="fixed inset-0 bg-transparent backdrop-blur-sm flex items-center justify-center z-50 p-4">
      {/* Modal Content */}
      <div className="bg-white rounded-lg shadow-2xl min-w-[30px] lg:min-w-sm relative p-20">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl cursor-pointer"
          aria-label="Close"
        >
          &times;
        </button>

        {children}
      </div>
    </div>
  )
}

export default OtpVerifyModal
